import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { dni } from './validator';

@Directive({
    selector: '[dni][formControlName],[dni][formControl],[dni][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DNIValidatorDirective),
            multi: true,
        },
    ],
})
export class DNIValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = dni();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
